import React from 'react';
import {
  Flex,
  PrimaryButton,
  Typography,
  useSafeArea,
  useScreenSize,
} from '@banhala/ui-kit';
import { Image } from 'react-native';

export const DefaultErrorBoundaryView: React.FC<{
  pageTitle: string;
  buttonText: string;
  descriptions: string[];
  showRefreshButton?: boolean;
  onPressButton: () => void;
}> = props => {
  const { descriptions, pageTitle, buttonText, showRefreshButton } = props;
  const { top, bottom } = useSafeArea();

  const { width: screenWidth } = useScreenSize();

  return (
    <Flex.Center flex={1} margin={{ top, bottom }}>
      <Image
        style={{
          width: 156,
          height: 156,
        }}
        source={{
          uri: 'https://img.a-bly.com/common/img-error@3x.png',
        }}
        alt="에러 이미지"
      />
      <Typography type="h3" marginBottom={16}>
        {pageTitle}
      </Typography>
      {[...descriptions].map(description => (
        <Typography key={description} type="body1" color="content_secondary">
          {description}
        </Typography>
      ))}
      <Flex width={screenWidth * 0.5} margin={{ top: 12 }}>
        {showRefreshButton && (
          <PrimaryButton variant={'fill'} onPress={props.onPressButton}>
            {buttonText}
          </PrimaryButton>
        )}
      </Flex>
    </Flex.Center>
  );
};
